module.exports = __webpack_public_path__ + "static/media/12.2062ec62.jpg";